/**
 * "Is this row held by another firma of my group?" — one answer for every combined-list screen
 * (skupina-vlastnictvi-plan §6.5). The active firma comes from `/auth/me`, the same source the
 * permission gates use, so a badge, the read-only detail and the edit refusal can never disagree.
 */

import { useMeQuery } from '@/modules/dashboard/api';

interface FirmaRow {
  id_firmy: number;
  firma_nazev?: string | null;
}

/** The active firma's id; null until `/auth/me` has loaded. */
export function useActiveFirmaId(): number | null {
  return useMeQuery().data?.company_id ?? null;
}

/** Name of the firma holding `row` when it is not the active one; null for an own row or while the active firma is unknown. */
export function otherFirmaName(row: FirmaRow, activeFirmaId: number | null): string | null {
  if (activeFirmaId == null || row.id_firmy === activeFirmaId) return null;
  return row.firma_nazev ?? 'jiné firmy';
}

/** The same for one row; `unresolved` is true while the active firma is still unknown. */
export function useOtherFirma(row: FirmaRow | null): { name: string | null; unresolved: boolean } {
  const activeFirmaId = useActiveFirmaId();
  return { name: row ? otherFirmaName(row, activeFirmaId) : null, unresolved: activeFirmaId == null };
}
